/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TypeTrigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TypeTrigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/TypeAndDuration/Content/TemplateSelect/Content/TypeTrigger"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let templatesValueData = fromData.useDataValue({ viewPath,
context: 'templates',
})
let appointmentOverlayAppointmentTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_type_id',
})
let aggregateData = fromHelpers.getColor(templatesValueData, appointmentOverlayAppointmentTypeIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let appointmentOverlayAppointmentTypeNameValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
path: 'appointment_type_name',
format: fromHelpers.getAppointmentTypeText,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="secondary"
>
{childProps => (
<div
  data-testid="TypeTrigger.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-1zq4Nb': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TypeTrigger.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-1zq4Nb': aggregateData,'--h-3-1zq4Nb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-4-1zq4Nb': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment_overlay.appointment_type_name"
 format="helpers.js getAppointmentTypeText"
 text={appointmentOverlayAppointmentTypeNameValueData}
 weight="medium"
 size="small"
 maxWidth={120}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="inline-block"
/>
</div>
)}
</TysiaButton>
{children}
</React.Fragment>)
}